import { AnimationBuilder, AnimationMetadata, animate, style } from '@angular/animations';
import { Directive, ElementRef, OnDestroy, effect, input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[errorDisplay]'
})
export class ErrorDisplayDirective implements OnDestroy {
  errorDisplay = input.required<boolean>();

  private isVisibleEffect = effect(() => {
    const metadata = this.errorDisplay() ? this.enter() : this.leave();

    const factory = this.builder.build(metadata);
    const player = factory.create(this.el.nativeElement);

    player.play();
  });

  constructor(private builder: AnimationBuilder, private el: ElementRef) {}

  ngOnDestroy(): void {
    this.isVisibleEffect.destroy();
  }

  private enter(): AnimationMetadata[] {
    return [
      style({ transform: 'translateY(-75%)', opacity: '0' }),
      animate('.6s cubic-bezier(0.55, 0.31, 0.15, 0.93)', style({ transform: 'translateY(0%)', opacity: '1' }))
    ];
  }

  private leave(): AnimationMetadata[] {
    return [
      animate('0.3s cubic-bezier(0.55, 0.31, 0.15, 0.93)', style({ transform: 'translateY(50%)', opacity: '0' }))
    ];
  }
}
